import moment from "moment";

export const GRAB_ORDER_DAILY_MAX = 6;
export const GRB_NTF_CLD_KEY = "grbNtfCld";
const GRB_NTF_CLD_DATE_KEY = "grbNtfCldDate";

const getTodayDateStr = () => moment().format("YYYY-MM-DD");

const toValidCount = (value) => {
  const parsed = Number(value);
  if (!Number.isInteger(parsed)) return null;
  if (parsed < 0) return 0;
  return Math.min(parsed, GRAB_ORDER_DAILY_MAX);
};

const initializeTodayIfNeeded = () => {
  const today = getTodayDateStr();
  const savedDate = localStorage.getItem(GRB_NTF_CLD_DATE_KEY);
  const savedCount = toValidCount(localStorage.getItem(GRB_NTF_CLD_KEY));

  if (savedDate !== today || savedCount === null) {
    localStorage.setItem(GRB_NTF_CLD_DATE_KEY, today);
    localStorage.setItem(GRB_NTF_CLD_KEY, String(GRAB_ORDER_DAILY_MAX));
    return GRAB_ORDER_DAILY_MAX;
  }

  return savedCount;
};

export const getRemainingGrabOrderNotificationCount = () => initializeTodayIfNeeded();

export const decrementRemainingGrabOrderNotificationCount = () => {
  const currentCount = initializeTodayIfNeeded();
  const updatedCount = Math.max(0, currentCount - 1);
  localStorage.setItem(GRB_NTF_CLD_KEY, String(updatedCount));
  return updatedCount;
};

export const setRemainingGrabOrderNotificationCount = (count) => {
  initializeTodayIfNeeded();
  const validCount = toValidCount(count);
  const updatedCount = validCount === null ? 0 : validCount;
  localStorage.setItem(GRB_NTF_CLD_KEY, String(updatedCount));
  return updatedCount;
};
